module.exports = __webpack_public_path__ + "img/cg_cat.b2f1a7c7.jpg";